const GeneratorOptions = (
  { options: { max = 1000000 } = {}, onChange, strings } = {
    options: {},
  }
) => {
  return (
    <>
      <div className={"row p-0 m-1 pb-2 d-flex"}>
        <div className="col col-4 col-md-2 col-xl-1">
          <label forhtml="lengthLabel">{strings.maxNumber}</label>
          <input
            className="form-control"
            type="number"
            value={isNaN(max) ? "" : max}
            onChange={({ target: { value } }) =>
              onChange({
                max:
                  parseInt(value) < 0
                    ? 1
                    : parseInt(value) > 100000000
                    ? 100000001
                    : parseInt(value),
              })
            }
          />
        </div>
      </div>
    </>
  );
};
export default GeneratorOptions;
